import React from "react";
import { Link } from "react-router-dom";
import { BondLockup } from "../../../components/BondMark";
import { THEME } from "../../theme";

/**
 * Split auth layout: brand panel + form panel.
 * Desktop: left identity, right form. Mobile: form only with logo.
 */
const AuthShell = ({
  title,
  subtitle,
  children,
  footer,
}) => (
  <div className="app-auth-bg min-h-screen">
    <div className="mx-auto grid min-h-screen max-w-[1120px] lg:grid-cols-2 lg:gap-0">
      {/* Brand panel (desktop only) */}
      <div className="relative hidden lg:flex flex-col justify-between px-6 py-10 sm:px-10 lg:px-14 lg:py-16">
        <div>
          <Link
            to="/"
            className="inline-flex opacity-90 transition-opacity hover:opacity-100"
            aria-label="BetBond home"
          >
            <BondLockup size={26} textClassName="text-2xl" />
          </Link>

          <div className="mt-14">
            <p
              className="text-[11px] font-bold uppercase tracking-[0.28em]"
              style={{ color: THEME.text.tertiary }}
            >
              Peer-to-peer · Escrowed · Rwanda
            </p>
            <h2 className="mt-4 text-4xl font-extrabold leading-[1.05] tracking-tight text-white">
              Make a{" "}
              <span style={{ color: THEME.primary }}>Bond.</span>
            </h2>
            <p
              className="mt-4 max-w-sm text-[15px] leading-relaxed"
              style={{ color: THEME.text.secondary }}
            >
              Funds stay in escrow until the rule clears. No house against you.
              Just two sides and a fair settlement.
            </p>
          </div>
        </div>

        <p className="text-[12px]" style={{ color: THEME.text.muted }}>
          © BetBond · Built in Rwanda
        </p>
      </div>

      {/* Form panel */}
      <div className="flex items-center justify-center px-4 py-10 sm:px-8 lg:px-10 lg:py-16">
        <div className="w-full max-w-[420px]">
          <div className="mb-8 flex justify-center lg:justify-start">
            <Link
              to="/"
              className="inline-flex opacity-90 transition-opacity hover:opacity-100 lg:hidden"
              aria-label="BetBond home"
            >
              <BondLockup size={24} textClassName="text-2xl" />
            </Link>
          </div>

          <div className="app-surface-card rounded-2xl p-7 sm:p-8">
            <div className="mb-7">
              <h1 className="text-[22px] font-extrabold tracking-tight text-white">
                {title}
              </h1>
              {subtitle && (
                <p
                  className="mt-2 text-[14px] leading-relaxed"
                  style={{ color: THEME.text.secondary }}
                >
                  {subtitle}
                </p>
              )}
            </div>

            {children}
          </div>

          {footer && <div className="mt-6">{footer}</div>}
        </div>
      </div>
    </div>
  </div>
);

export default AuthShell;
